import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { Dialog } from "primereact/dialog";
import _ from "lodash";

import CopyToClipboard from "../../../../common/CopyToClipboard";

import QuotationModalData from "./QuotationModalData";

import { raiseToast } from "../../../../services/redux/reducers/toast/toast";
import { getBuyerQuoteItemByBuyerQuoteIds } from "../../../../services/api/buyerQuoteItem";
import { deleteQuote } from '../../../../services/redux/reducers/Requirement/requirement';


const QuotationModal = (props) => {
    const navigate = useNavigate()
    const { selectedReq, buyerPOs, visibleQuotes, setVisibleQuotes, setIsPageLoading } = props
    
    const [buyerQuotes, setBuyerQuotes] = useState([])
    const [buyerQuoteItems, setBuyerQuoteItems] = useState([])
    const [materialDetails, setMaterialDetails] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const dispatch = useDispatch()
    const buyerQuoteData = useSelector(state => state.requirementDashboard.buyerQuoteData)

    useEffect(() => {
        getBuyerQuotes()
    }, [buyerQuoteData, selectedReq])

    const getBuyerQuotes = async () => {
        setIsLoading(true)
        const relatedBuyerQuotes = props.buyerQuotes?.filter(eachBuyerQuote => eachBuyerQuote?.buyerReqId === selectedReq?.buyerReqId)

        const buyerQuoteIds = relatedBuyerQuotes?.map(eachBuyerQuote => eachBuyerQuote?.buyerQuoteId)

        let relatedBuyerQuoteItems = []

        const buyerQuoteItemsRes = await getBuyerQuoteItemByBuyerQuoteIds(buyerQuoteIds)
        if (buyerQuoteItemsRes?.failure){
            return dispatch(raiseToast({ severity: 'error', summary: "Buyer Quote Items", detail: buyerQuoteItemsRes?.data?.error, life: 3000 }))
        }
        relatedBuyerQuoteItems = buyerQuoteItemsRes.data

        setBuyerQuotes(relatedBuyerQuotes)
        setBuyerQuoteItems(relatedBuyerQuoteItems)
        setMaterialDetails(props.materialDetails)
        setIsLoading(false)
    }

    const statusOptions = [
        { name: 'Won'},
        { name: 'Lost'},
        { name: 'Cancelled'},
        { name: 'Alternative Product Selected'},
        { name: 'Revised Offer to be submitted'},
    ]

    const handleDeleteClick = async (data) => {
        const updatedBuyerQuoteList = buyerQuoteData.data.buyerQuotes.map((eachBuyerQuote) => {
            if (eachBuyerQuote.buyerQuoteId === data.updatedBuyerQuote.buyerQuoteId) {
                return { ...eachBuyerQuote, statusId: data.updatedBuyerQuote.statusId }
            }
            return eachBuyerQuote
        })
        const updatedBuyerQuoteData = { ...buyerQuoteData, data: { ...buyerQuoteData.data, buyerQuotes: updatedBuyerQuoteList }}
        dispatch(deleteQuote(updatedBuyerQuoteData))

        const updatedBuyerQuoteItems = buyerQuoteItems.map(eachQuoteItem => {
            const relatedBUyerQuoteItem = data.updatedBuyerQuoteItems.find(eachQuoteItem => eachQuoteItem.buyerQuoteItemId === eachQuoteItem.buyerQuoteItemId)
            if(relatedBUyerQuoteItem){
                return { ...eachQuoteItem, ...relatedBUyerQuoteItem }
            }
            return eachQuoteItem
        })
        setBuyerQuoteItems([...updatedBuyerQuoteItems])

        dispatch(raiseToast({severity:'warn', detail: "Buyer quote deleted successfully", life: 3000}))
        getBuyerQuotes()
    }

    let buyerName = ""
    if(selectedReq["buyer.firstName"]){
        buyerName = selectedReq["buyer.firstName"]
    }
    if(selectedReq["buyer.lastName"]){
        buyerName += " " + selectedReq["buyer.lastName"]
    }

    const handleOnHideDialog = () => {
        setBuyerQuoteItems([])
        setBuyerQuotes([])
        setVisibleQuotes(false)
    }

    
    return (
        <Dialog header="Quotes" className="quotation-dialog buyer-quotation-modal" visible={visibleQuotes} style={{ width: '90vw', height: '85vh'}} onHide={() => handleOnHideDialog()}>
            <div className="quotation-modal">

                { selectedReq ? 
                    <p className="m-0">
                        <span style={{fontWeight:"bold"}}> Requirement No: </span><span className="ml-1 req-no">{selectedReq["docNo"]} <CopyToClipboard text={selectedReq["docNo"]} /></span>
                        {/* <span className="ml-5" style={{fontWeight:"bold"}}> Buyer: </span> {selectedReq["company.companyName"]} - {selectedReq["buyerCompanyBranch.branchName"]} - {buyerName} */}
                    </p> 
                    : "" 
                }
                {
                    isLoading ?
                        (
                            <div className="flex justify-content-center align-items-center h-full">
                                <ThreeDots height="50" width="50" radius="5"color="#00baac" ariaLabel="three-dots-loading" visible={isLoading} /> 
                            </div>
                        ) : 
                        (
                            <>
                                {
                                    buyerQuotes?.length === 0 ? (
                                        <div className="flex justify-content-center mt-2">
                                            <p className="font-bold">Buyer quotes has not found for the selected buyer req.</p>
                                        </div>
                                    ) : (
                                        buyerQuotes?.map(eachBuyerQuote => {
                                            const relatedBuyerPO = buyerPOs?.find(eachBuyerPO => eachBuyerPO?.buyerQuoteId === eachBuyerQuote?.buyerQuoteId && eachBuyerPO?.statusId === 3)
                                            const relatedBuyerQuoteItems = buyerQuoteItems?.filter(eachBuyerQuoteItem => eachBuyerQuoteItem?.buyerQuoteId === eachBuyerQuote?.buyerQuoteId)

                                            const buyerReqItemIds = [] 
                                            let uniqueBuyerQuoteItems = []
                                            relatedBuyerQuoteItems.forEach(eachQuoteItem => {
                                                if(!buyerReqItemIds.includes(eachQuoteItem.buyerReqItemId)){
                                                    uniqueBuyerQuoteItems = [...uniqueBuyerQuoteItems, eachQuoteItem]
                                                    buyerReqItemIds.push(eachQuoteItem.buyerReqItemId)
                                                }
                                            })

                                            return (
                                                <QuotationModalData key={`buyerQuote-${eachBuyerQuote.buyerQuoteId}`} selectedReq={selectedReq} setIsPageLoading={setIsPageLoading} buyerQuote={eachBuyerQuote} activeBuyerPO={relatedBuyerPO} buyerQuoteItems={uniqueBuyerQuoteItems} materialDetails={materialDetails} statusOptions={statusOptions} handleDeleteClick={handleDeleteClick}/>
                                            )
                                        })
                                    )
                                }
                            </>
                        )      
                }
            </div>
        </Dialog>
    )
}

export default QuotationModal